export enum FantasyPosition {
    Unallocated = 'Unallocated',
    Exited = 'Exited',
    Short = 'Short',
    Long = 'Long',
}
